import { ReactNode } from "react";
import { NavLink } from "react-router-dom";

export interface MenuOption{
    name:string;
    dest:string;
}

export const SubMenuItem = ({name,dest}:MenuOption) => {
    return <li className="naranja ">
        <NavLink className="dropdown-item naranja monse" style={{fontWeight:"500"}}  to={dest}>
        <span className="w-100" data-bs-target="#navbarSupportedContent" data-bs-toggle="collapse"> {" "}{name}{" "}</span>
        </NavLink>
    </li>
}

export default SubMenuItem